import React from "react";
import FieldProto from "../../../../proto/field-proto";

export type FormValueNotEmptyProps = {

    // double check props...

    className?  : string
    value       : any
    field       : FieldProto
    disabled    : boolean

    onClick     : callback

    children?   : any
}

export default function FormFieldWithPopoverValueNotEmpty(props:FormValueNotEmptyProps) {
    const valueClasses = Classes("ui5-txt-default ui5-field-form-editable dropdown-form h-36", props.className,)

    return (
        <React.Fragment>
            <div className={valueClasses} onClick={props.onClick}>
                {_.get(props.field.components, 'ValueIcon', false)}
                {props.value}
            </div>
            {props.children}
        </React.Fragment>
    );
}
